export default __webpack_public_path__ + "static/ygzl-c606a255772402203aebc25f732e7fcb.jpeg";